// askCardOptions(card) — the answers of an ask_user question card (a
// `choice` or a `confirm` card on an assistant message), one row each:
// `{ at, label, value, primary, chosen }`.
//
// ONE rule for every surface that asks (coordinator F2, 2026-10-28): the
// thread's ChatCard (scope.choiceOptions) and AiAsk — the island and the
// full-screen call — read it through `el.call('askCardOptions', card)`, so
// `this` is the calling element (its `polyglot`). The two copies it replaced
// already differed on an option that is not an object.
//
//   • a confirm card answers with its own two labels (the tool's words), else
//     Confirm / Cancel in the active language; the first is the primary;
//   • a choice card answers with its options in their order, each with its
//     value (else its label); `primary` only where the option says so;
//   • an answered card (a pick, not words: never Write my own, an Edit or a
//     question a new message closed) marks its pick `chosen`, and then no row
//     is primary — the chosen capsule is the one fill;
//   • an option that is not an object, or that has no label and no value
//     (nothing to show, nothing to send), is skipped; every row keeps its
//     place (`at`), so a caller's key stays stable.
//
// The caller reads `root.lang` itself (a reactive factory subscribes to the
// language where it reads it).
export function askCardOptions(card) {
  const s = card && typeof card === 'object' ? card : null
  if (!s) return []
  const confirm = s.type === 'confirm'
  const opts = confirm
    ? [
        {
          label: s.confirmLabel || this.call('polyglot', 'ai.chatCard.confirm'),
          value: 'confirm',
          primary: true
        },
        { label: s.cancelLabel || this.call('polyglot', 'ai.chatCard.cancel'), value: 'cancel' }
      ]
    : Array.isArray(s.options)
      ? s.options
      : []
  // The current answer of an answered card (a pick, not words).
  const picked =
    s._resolved && !s._superseded && !s._written && !s._edit && s._chosen != null
      ? String(s._chosen)
      : null
  const out = []
  opts.forEach((o, at) => {
    if (!o || typeof o !== 'object') return
    const value = o.value != null ? o.value : o.label
    if (value == null) return
    out.push({
      at,
      label: o.label != null ? String(o.label) : String(value),
      value,
      primary: picked == null && (!!o.primary || (confirm && at === 0)),
      chosen: picked != null && String(value) === picked
    })
  })
  return out
}
